import React, { Component } from "react";
import { connect } from "react-redux";
import ProductList from "../components/ProductList";
import { ExternalHashDropdown } from "../components/ExternalHashDropdown";
import { Tooltip } from "react-tippy";
import "react-tippy/dist/tippy.css";
import "../resources/stylesheets/dashboard.css";
import { NoInfo } from "../components/structure/NoInfo";
import ComponentModal from "../components/ComponentModal";
import { Overlay } from "clorian-frontend-components";
import { fetchLanguages } from "../login/api.actions";
import { fetchSalesGroups } from "../actions/salesGroups";
import { fetchProducts } from "../actions/products";
import { fetchItems } from "../actions/items";
import { Tab, Tabs } from "react-bootstrap";
import GenericUrls from "../components/GenericUrls";
import { updateCurrentHash } from "../actions/affiliates";
import GenericBanners from "../components/GenericBanners";

class HomeContainer extends Component {
  constructor(props) {
    super(props);

    this.handleHashChange = this.handleHashChange.bind(this);
    this.handleProductClick = this.handleProductClick.bind(this);
    this.handleIframeClick = this.handleIframeClick.bind(this);
    this.handleUrlClick = this.handleUrlClick.bind(this);
    this.handleGenericBannerClick = this.handleGenericBannerClick.bind(this);
    this.handleBannerClick = this.handleBannerClick.bind(this);
    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);

    this.state = {
      showModal: false,
      value: "",
      modalDetails: "",
      sgId: null,
      prod: null,
    };
  }

  openModal(modalDetails) {
    this.setState({ showModal: true, modalDetails: modalDetails });
  }

  closeModal(e) {
    this.setState({ showModal: false });
  }

  handleHashChange(hash) {
    const { dispatch } = this.props;
    dispatch(updateCurrentHash(hash.value));
  }

  setModalDetails(prod, sgId, modalDetails) {
    this.setState({ copied: false, sgId: sgId, prod: prod });
    this.openModal(modalDetails);
  }

  handleProductClick(prod, sgID) {
    const modalDetails = { modalType: "linkModal", modalTitle: "URL to add" };
    this.setModalDetails(prod, sgID, modalDetails);
  }

  handleIframeClick(prod, sgId) {
    const modalDetails = {
      modalType: "iFrameModal",
      modalTitle: "Iframe to embed",
    };
    this.setModalDetails(prod, sgId, modalDetails);
  }

  handleUrlClick(prod, sgId, customUrls) {
    const modalDetails = {
      modalType: "customUrls",
      modalTitle: "Custom URLs",
      customUrls: customUrls,
    };
    this.setModalDetails(prod, sgId, modalDetails);
  }

  handleBannerClick(prod, sgId, bannerList) {
    const modalDetails = {
      modalType: "customBanners",
      modalTitle: "Custom Banners",
      bannerList: bannerList,
    };
    this.setModalDetails(prod, sgId, modalDetails);
  }

  handleGenericBannerClick(itemResource, itemLinkedUrl) {
    const modalDetails = {
      modalType: "genericBanner",
      modalTitle: "Preview",
      imgSrc: itemResource,
      href: itemLinkedUrl,
    };
    this.setModalDetails(null, null, modalDetails);
  }

  shouldComponentUpdate() {
    const { externalHashList, clientDetails } = this.props;

    return !(
      (externalHashList && externalHashList.length === 0) ||
      (clientDetails && clientDetails.length === 0)
    );
  }

  componentDidMount() {
    const { dispatch, clientDetails } = this.props;

    if (clientDetails.clientId) {
      dispatch(
        fetchSalesGroups({
          clientId: clientDetails.clientId,
          salesChannelId: 1,
        })
      ).then(({ response }) => {
        if (response && response.length > 0) {
          const sgs = [];
          response.forEach((sg) => {
            sgs.push(sg.salesGroupId);
          });
          dispatch(fetchProducts({ salesGroupIdList: sgs }));
        }
      });

      dispatch(fetchLanguages(clientDetails.clientId));
      dispatch(fetchItems(clientDetails.clientId));
    }
  }

  render() {
    const {
      prodList,
      clientDetails,
      externalHashList,
      affWebsite,
      loading,
      languages,
      genericUrls,
      genericBanners,
      currentHash,
    } = this.props;
    const { showModal, modalDetails, sgId, prod } = this.state;

    return (
      <div className="container">
        <Overlay loading={loading} />
        {clientDetails && prodList && prodList.length > 0 && languages ? (
          <div className="mainBody">
            <div className="selectIdentifierCont">
              <label className="selectIdentifier">
                1. Select Campaign Name :
              </label>

              <Tooltip
                title="Link your campaign name to the product"
                position="right"
                trigger="click"
                size="big"
              >
                <span className="glyphicon glyphicon-info-sign"></span>
              </Tooltip>

              <ExternalHashDropdown
                selectedVal={currentHash}
                externalHashList={externalHashList}
                handleHashChange={this.handleHashChange}
              />
            </div>

            <label className="selectIdentifier margLeft">
              2. Select Item :{" "}
            </label>

            <Tabs id="itemTabs">
              <Tab eventKey="product" title="Product">
                <ProductList
                  prodList={prodList}
                  handleProductClick={this.handleProductClick}
                  handleIframeClick={this.handleIframeClick}
                  handleUrlClick={this.handleUrlClick}
                  handleBannerClick={this.handleBannerClick}
                />
              </Tab>

              <Tab eventKey="genericUrl" title="Generic URLs">
                <GenericUrls
                  genericUrls={genericUrls}
                  languages={languages}
                  currentHash={currentHash}
                  affWebsite={affWebsite}
                />
              </Tab>

              <Tab eventKey="genericBanner" title="Generic Banners">
                <GenericBanners
                  genericBanners={genericBanners}
                  currentHash={currentHash}
                  affWebsite={affWebsite}
                  handleGenericBannerClick={this.handleGenericBannerClick}
                />
              </Tab>
            </Tabs>

            {showModal && (
              <ComponentModal
                showModal={showModal}
                modalDetails={modalDetails}
                currentHash={currentHash}
                closeModal={this.closeModal}
                affWebsite={affWebsite}
                languages={languages}
                clientHostName={clientDetails.urlHostname}
                clientUrlName={clientDetails.clientUrlName}
                sgId={sgId}
                prod={prod}
              />
            )}
          </div>
        ) : (
          <NoInfo displayMsg="There are no products available at this time" />
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const {
    products,
    affiliates,
    clients,
    salesGroups,
    languages,
    items,
  } = state;
  let clientDetails = {};

  if (clients.clientList && affiliates.currentAffiliate) {
    clients.clientList.forEach((c) => {
      if (affiliates.currentAffiliate.clientId === c.clientId) {
        clientDetails = c;
      }
    });
  }

  return {
    currentAffiliate: affiliates.currentAffiliate,
    currentHash: affiliates.currentHash,
    prodList: products.productList,
    loading: products.isFetching,
    affiliatesList: affiliates.affiliatesList,
    clientDetails: clients && clientDetails,
    salesGroups: salesGroups && salesGroups.salesGroupIdList,
    externalHashList:
      affiliates && affiliates.currentAffiliate.affiliateExternalHashList,
    affWebsite: affiliates && affiliates.currentAffiliate.website,
    languages: languages && languages.languageList,
    genericUrls: items && items.genericUrls,
    genericBanners: items && items.genericBanners,
    urlsByProduct: items && items.urlsByProduct,
  };
};

export default connect(mapStateToProps)(HomeContainer);
